import api from "api";
import { DownloadConfig } from "./types";

export async function viewResource(url: string, config: DownloadConfig) {
  let docType = "";
  switch (config?.type) {
    case ".pdf":
      docType = "application/pdf";
      break;
    case "Report":
      docType = "application/pdf";
      break;
    case ".mp3":
      docType = "audio/mp3";
      break;
    case ".doc":
      docType = "application/msword";
      break;
    case ".docx":
      docType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      break;
    default:
      docType = "link";
  }

  if (docType === "link") {
    const fr = document.createElement("iframe");
    fr.frameBorder = "0";
    fr.width = "1";
    fr.height = "1";
    document.body.appendChild(fr);
    const link = document.createElement("a");
    const resourceUrl = config?.link;
    if (
      (resourceUrl && resourceUrl.indexOf("://") > 0) ||
      (resourceUrl && resourceUrl.indexOf("//") === 0)
    ) {
      link.href = config?.link ? config.link : "";
    } else {
      link.href = config?.link ? `https://${config.link}` : "";
    }
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "external");
    fr.contentDocument?.body.appendChild(link);
    link.click();
    setTimeout(function() {
      fr.parentNode?.removeChild(fr);
    }, 100);
  } else {
    try {
      const { data } = await api.get(config?.link, {
        responseType: "blob",
      });
      const viewUrl = window.URL.createObjectURL(
        new Blob([data], { type: docType })
      );
      window.open(viewUrl, "_blank");
    } catch (err) {
      throw err;
    }
  }
}
